import { useNavigate } from "react-router-dom";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../../Buttons/MainButton";
import Input from "../../../Inputs/Input";
import Title from "../../../Title/Title";
import { usePOST } from "../../../../ApiS";
import React, { useState } from "react";
import Selected from "../../../Inputs/Selected";
import { toast, ToastContainer } from "react-toastify";
import { AxiosError } from "axios";

interface infos extends Record<string, string | undefined> {
  title?: string;
  thesis_title?: string;
  university_name?: string;
  collage_name?: string;
  specialization?: string;
  degree?: string;
  rate?: string;
  graduation_year?: string;
}

interface position extends Record<string, string | undefined> {
  name?: string;
  start_year?: string;
  end_year?: string;
}

interface achievement extends Record<string, string | undefined> {
  title?: string;
  text?: string;
  type?: string;
}

interface MessageError {
  academic_rank?: string[];
  email?: string[];
  phone?: string[];
  fax?: string[];
  mobile?: string[];
  title?: string[];
  thesis_title?: string[];
  university_name?: string[];
  collage_name?: string[];
  specialization?: string[];
  degree?: string[];
  rate?: string[];
  graduation_year?: string[];
  name?: string[];
  start_year?: string[];
  end_year?: string[];
  text?: string[];
  type?: string[];
}

export default function AddInfoTeaches() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<MessageError>({});
  const [infos, setinfos] = useState<infos>({
    title: "",
    thesis_title: "",
    university_name: "",
    collage_name: "",
    specialization: "",
    degree: "",
    rate: "",
    graduation_year: "",
  });

  const [position, setposition] = useState<position>({
    name: "",
    start_year: "",
    end_year: "",
  });

  const [achievement, setachievement] = useState<achievement>({
    title: "",
    text: "",
    type: "",
  });

  const onError = (
    error: AxiosError<{ errors: MessageError; message: string }>
  ) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const { handleChangeInput, handleSubmit, setFormData, formData } = usePOST(
    {},
    () => {
      navigate("/infomation_application/teaching_staff");
    },
    (error) => {
      onError(error);
    }
  );

  const handleChangeInfos = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setinfos((prevInfos) => ({
      ...prevInfos,
      [name]: value,
    }));
  };

  const handleChangePosition = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setposition((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAchievement = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setachievement((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filterFilledFields = <T extends Record<string, string | undefined>>(
    data: T
  ): Partial<T> => {
    return Object.fromEntries(
      Object.entries(data).filter(
        ([_, value]) => value !== "" && value !== undefined
      )
    ) as Partial<T>;
  };

  const handleFormSubmit = async () => {
    const filteredInfos = filterFilledFields(infos);
    const filteredPosition = filterFilledFields(position);
    const filteredAchievement = filterFilledFields(achievement);

    await setFormData((prevFormData) => ({
      ...prevFormData,
      infos: JSON.stringify(filteredInfos),
    }));

    await setFormData((prevFormData) => ({
      ...prevFormData,
      position: JSON.stringify(filteredPosition),
    }));

    await setFormData((prevFormData) => ({
      ...prevFormData,
      achievement: JSON.stringify(filteredAchievement),
    }));

    handleSubmit("admin/doctors");
  };

  return (
    <>
      <ToastContainer position="bottom-left" />
      <Row>
        <Col lg={4}>
          <Title title="اضف معلومات الدكتور" />
        </Col>
      </Row>

      <Row justify={"center"} className="!mt-8 ">
        <Col lg={10} sm={10}>
          <Input
            name="academic_rank"
            placeholder="المرتبة العلمية"
            title="المرتبة العلمية"
            onChange={handleChangeInput}
          />
          {errors?.academic_rank &&
            errors?.academic_rank.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="email"
            name="email"
            placeholder="أيميل الدكتور"
            title="أيميل الدكتور"
            onChange={handleChangeInput}
          />
          {errors?.email &&
            errors?.email.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="number"
            name="phone"
            placeholder="رقم الدكتور"
            title="رقم الدكتور"
            onChange={handleChangeInput}
          />
          {errors?.phone &&
            errors?.phone.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="number"
            name="fax"
            placeholder="فاكس الدكتور"
            title="فاكس الدكتور"
            onChange={handleChangeInput}
          />
          {errors?.fax &&
            errors?.fax.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="number"
            name="mobile"
            placeholder="رقم الدكتور"
            title="رقم الدكتور"
            onChange={handleChangeInput}
          />
          {errors?.mobile &&
            errors?.mobile.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Row justify="center" className=" border-2 border-black ">
          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="title"
              placeholder=" عنوان الدكتور "
              title=" عنوان الدكتور "
              onChange={handleChangeInfos}
            />
            {errors?.title &&
              errors?.title.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="thesis_title"
              placeholder="عنوان الاطروحة"
              title="عنوان الاطروحة"
              onChange={handleChangeInfos}
            />
            {errors?.thesis_title &&
              errors?.thesis_title.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>

          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="university_name"
              placeholder=" اسم الجامعة "
              title=" اسم الجامعة "
              onChange={handleChangeInfos}
            />
            {errors?.university_name &&
              errors?.university_name.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="collage_name"
              placeholder=" اسم الكلية "
              title=" اسم الكلية "
              onChange={handleChangeInfos}
            />
            {errors?.collage_name &&
              errors?.collage_name.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="specialization"
              placeholder=" الاختصاص "
              title=" الاختصاص "
              onChange={handleChangeInfos}
            />
            {errors?.specialization &&
              errors?.specialization.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={10} sm={10}>
            <Input
              type="text"
              name="degree"
              placeholder=" الدرجة "
              title=" الدرجة "
              onChange={handleChangeInfos}
            />
            {errors?.degree &&
              errors?.degree.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>

          <Col lg={10} sm={10}>
            <Input
              type="number"
              name="rate"
              placeholder=" التقييم "
              title=" التقييم "
              onChange={handleChangeInfos}
            />
            {errors?.rate &&
              errors?.rate.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={10} sm={10}>
            <Input
              type="date"
              name="graduation_year"
              placeholder=" سنة التخرج "
              title=" سنة التخرج "
              onChange={handleChangeInfos}
            />
            {errors?.graduation_year &&
              errors?.graduation_year.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
        </Row>
      </Row>

      <Row justify="center" className=" border-2 border-black ">
        <Col lg={10} sm={10}>
          <Input
            type="text"
            name="name"
            placeholder=" اسم المنصب "
            title=" اسم المنصب "
            onChange={handleChangePosition}
          />
          {errors?.name &&
            errors?.name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="date"
            name="start_year"
            placeholder="  تاريخ البداية "
            title="  تاريخ البداية "
            onChange={handleChangePosition}
          />
          {errors?.start_year &&
            errors?.start_year.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <Input
            type="date"
            name="end_year"
            placeholder="  تاريخ النهاية "
            title="  تاريخ النهاية "
            onChange={handleChangePosition}
          />
          {errors?.end_year &&
            errors?.end_year.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
      </Row>

      <Row justify="center" className=" border-2 border-black ">
        <Col lg={10} sm={10}>
          <Input
            type="text"
            name="title"
            placeholder=" العنوان "
            title=" العنوان "
            onChange={handleChangeAchievement}
          />
          {errors?.title &&
            errors?.title.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={10} sm={10}>
          <Input
            type="text"
            name="text"
            placeholder=" الاسم "
            title=" الاسم "
            onChange={handleChangeAchievement}
          />
          {errors?.text &&
            errors?.text.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <Selected name="type" onChange={handleChangeAchievement}>
            <option value="" disabled hidden>
              النوع{" "}
            </option>
            <option value="scientific_research"> البحث_العلمي </option>
            <option value="books_and_scientific_publications">
              {" "}
              الكتب_والمنشورات_العلمية{" "}
            </option>
            <option value="conferences"> المؤتمرات </option>
            <option value="teaching_experience"> خبرة التدريس </option>
          </Selected>
          {errors?.type &&
            errors?.type.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
      </Row>

      <Row className="flex justify-evenly !mt-4 ">
        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="اضافة"
            className="w-full"
            onClick={handleFormSubmit}
          />
        </Col>

        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="الغاء"
            className="w-full !bg-gray-200 !text-Secondary"
            onClick={() => navigate(-1)}
          />
        </Col>
      </Row>
    </>
  );
}
